const url = process.env.NODE_ENV === 'production' ? 'https://cp.al-jariyah.com' : 'https://cpdemo-kariah.al-jariyah.com'
const url2 = process.env.NODE_ENV === 'production' ? 'https://kariah.al-jariyah.com' : 'https://demo-kariah.al-jariyah.com'

const menus = [
    {
        id: 1,
        name: 'Laman Utama',
        links: '/',  
    },
    {
        id: 2,
        name: 'Mengenai Al-Jariyah',
        links: '/mengenai-aljariyah',
    },
    {
        id: 3,
        name: 'Senarai Institusi',
        links: '/senarai-institusi',
    },
    {
        id: 4,
        name: 'Berita & Aktiviti',
        links: '/berita-aktiviti',
    },
    {
        id: 5,
        name: 'Tambahan',
        links: '#',
        namesub: [
            {
                id: 1,
                sub: 'Pendaftaran Institusi ',
                links: `${url}/register`
            },
            {
                id: 2,
                sub: 'Log Masuk Institusi',
                links: `${url}/login`
            },
            {
                id: 3,
                sub: 'Log Masuk Ahli Kariah',
                links: `${url2}/`
            }
        ],
    },
]

export default menus;